'use client';

import { FC, ReactNode } from 'react';
import { ButtonBase } from '../../../common/components/ButtonBase/ButtonBase';
import { Drawer } from '../../../common/components/Drawer/Drawer';
import { DrawerTriggerButton } from '../../../common/components/Drawer/DrawerTriggerButton';
import { useClientUserInfo } from '../../../common/userinfo/InitialUserInfoFetcherAndParser/utils/useClientUserInfo';
import { useModalDrawerContext } from '../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { UserTypes, UserAccessModal, AccessInfoType } from '../../../common';

export const CryptoTransfersDrawer: FC<{
  buttonTransferTopNav: string;
  contentNode: ReactNode;
}> = ({ buttonTransferTopNav, contentNode }) => {
  const CryptoTransferDrawer = () => (
    <Drawer hideDefaultHeader>{contentNode}</Drawer>
  );

  const { showModal, close } = useModalDrawerContext();

  const { approved, userType, active, verified, onboarded } =
    useClientUserInfo();

  const isDepositNotAllowed =
    userType == UserTypes.BUSINESS_USER
      ? !approved
      : !active || !verified || !onboarded;

  const displayApprovalWarningModal = () => {
    if (isDepositNotAllowed) {
      showModal(UserAccessModal, {
        type: AccessInfoType.WarningTransfer,
        onModalClose: close,
      });
    }
  };

  return (
    <DrawerTriggerButton
      DrawerComponent={CryptoTransferDrawer}
      onClick={displayApprovalWarningModal}
      isDrawerOpeningNotAllowed={isDepositNotAllowed}
      drawerProps={{
        disableOverlayClose: true,
        disableCloseButton: true,
      }}
    >
      <ButtonBase
        visual="secondary"
        size="small"
        data-testid="crypto-transfer-button"
      >
        {buttonTransferTopNav}
      </ButtonBase>
    </DrawerTriggerButton>
  );
};
